module.exports = __webpack_public_path__ + "static/media/home_1920x1080.75078b73.png";